import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { playerSelectors, playerActions } from 'store/player';
import Player from 'components/Player';
import withBackSupport from 'components/HOCs/withBackSupport';

type MatchParamsType = {
  objectId: string;
  episodeId: string;
  channelId: string;
};

const PlayerPage: React.FC = () => {
  const match = useRouteMatch<MatchParamsType>();
  const dispatch = useDispatch();
  const playerType = useSelector(playerSelectors.selectPlayerType);

  const queryParams = useMemo(() => {
    const objectId = parseInt(match.params.objectId, 10) || null;
    const episodeId = parseInt(match.params.episodeId, 10) || null;
    const channelId = parseInt(match.params.channelId, 10) || null;
    return { objectId, episodeId, channelId };
  }, [match]);

  const object = useSelector(
    playerSelectors.createPlayerContentSelector({ playerType, queryParams }),
  );

  const isObjectLoading = useSelector(
    playerSelectors.createPlayerContentIsLoadingSelector({ playerType, queryParams }),
  );
  const navigation = useSelector(
    playerSelectors.createPlayerNavigationSelector({ playerType, queryParams }),
  );

  useEffect(() => {
    dispatch(playerActions.loadPlayerData({ queryParams, playerType }));
  }, [dispatch, playerType, queryParams]);

  return (
    <Player
      playerType={playerType}
      queryParams={queryParams}
      navigation={navigation}
      object={object}
      isObjectLoading={isObjectLoading}
    />
  );
};

export default withBackSupport(PlayerPage);
